"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function cov_aq42ke1ax() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/GlobalStylesCreator.js";
  var hash = "0b602df7481de56be509669cf70eb1d5c093f0fd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/GlobalStylesCreator.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 21
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "1": {
        start: {
          line: 27,
          column: 24
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "2": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 17
        }
      },
      "3": {
        start: {
          line: 40,
          column: 32
        },
        end: {
          line: 40,
          column: 37
        }
      },
      "4": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 49
        }
      },
      "5": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 34
        }
      },
      "6": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 28
        }
      },
      "7": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 23
        }
      },
      "8": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 23
        }
      },
      "9": {
        start: {
          line: 63,
          column: 24
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "10": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 55
        }
      },
      "11": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "12": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 13
        }
      },
      "13": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 42
        }
      },
      "14": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "15": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 13
        }
      },
      "16": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 42
        }
      },
      "17": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 51
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        loc: {
          start: {
            line: 58,
            column: 25
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 58
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 17
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 16
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 67
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 16
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        },
        loc: {
          start: {
            line: 85,
            column: 11
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 85
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 64,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 64,
            column: 18
          }
        }, {
          start: {
            line: 64,
            column: 22
          },
          end: {
            line: 64,
            column: 54
          }
        }],
        line: 64
      },
      "1": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 68
      },
      "2": {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 75
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0b602df7481de56be509669cf70eb1d5c093f0fd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_aq42ke1ax = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_aq42ke1ax();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Component for dynamically injecting global styles into a React application.
 * @extends React.Component
 */
var GlobalStylesCreator = /*#__PURE__*/function (_React$Component) {
  /**
   * Constructs a new GlobalStylesCreator component.
   * @param {Object} props - Component props.
   * @param {string} props.styles - CSS styles to be injected globally.
   * @param {string} [props.styleId] - Optional ID for the <style> element.
   */
  function GlobalStylesCreator(props) {
    var _this;
    (0, _classCallCheck2.default)(this, GlobalStylesCreator);
    cov_aq42ke1ax().f[0]++;
    cov_aq42ke1ax().s[2]++;
    _this = _callSuper(this, GlobalStylesCreator, [props]);
    var _ref = (cov_aq42ke1ax().s[3]++, props),
      styles = _ref.styles,
      styleId = _ref.styleId;

    /** @type {HTMLStyleElement} */
    cov_aq42ke1ax().s[4]++;
    _this.style = document.createElement('style');
    cov_aq42ke1ax().s[5]++;
    _this.style.innerHTML = styles;
    cov_aq42ke1ax().s[6]++;
    _this.style.id = styleId;
    return _this;
  }

  /**
   * Lifecycle method called after the component has been rendered to the DOM.
   */
  (0, _inherits2.default)(GlobalStylesCreator, _React$Component);
  return (0, _createClass2.default)(GlobalStylesCreator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_aq42ke1ax().f[1]++;
      cov_aq42ke1ax().s[7]++;
      this.appendStyle();
    }

    /**
     * Lifecycle method called before the component is removed from the DOM.
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_aq42ke1ax().f[2]++;
      cov_aq42ke1ax().s[8]++;
      this.removeStyle();
    }
  }, {
    key: "isStyleExist",
    value: function isStyleExist() {
      cov_aq42ke1ax().f[3]++;
      var _ref2 = (cov_aq42ke1ax().s[9]++, this.props),
        styleId = _ref2.styleId;
      cov_aq42ke1ax().s[10]++;
      return (cov_aq42ke1ax().b[0][0]++, styleId) && (cov_aq42ke1ax().b[0][1]++, document.getElementById(styleId));
    }
  }, {
    key: "appendStyle",
    value: function appendStyle() {
      cov_aq42ke1ax().f[4]++;
      cov_aq42ke1ax().s[11]++;
      if (this.isStyleExist()) {
        cov_aq42ke1ax().b[1][0]++;
        cov_aq42ke1ax().s[12]++;
        return;
      } else {
        cov_aq42ke1ax().b[1][1]++;
      }
      cov_aq42ke1ax().s[13]++;
      document.head.appendChild(this.style);
    }
  }, {
    key: "removeStyle",
    value: function removeStyle() {
      cov_aq42ke1ax().f[5]++;
      cov_aq42ke1ax().s[14]++;
      if (!document.head.contains(this.style)) {
        cov_aq42ke1ax().b[2][0]++;
        cov_aq42ke1ax().s[15]++;
        return;
      } else {
        cov_aq42ke1ax().b[2][1]++;
      }
      cov_aq42ke1ax().s[16]++;
      document.head.removeChild(this.style);
    }

    /**
     * Renders the child components.
     * @returns {React.ReactNode} Child components.
     */
  }, {
    key: "render",
    value: function render() {
      cov_aq42ke1ax().f[6]++;
      cov_aq42ke1ax().s[17]++;
      return this.props.children;
    }
  }]);
}((_react.default.Component));
/**
 * PropTypes for GlobalStylesCreator component.
 * @type {Object}
 * @property {React.ReactNode} children - Child components to render.
 * @property {string} styles - CSS styles to be injected globally.
 * @property {string} [styleId] - Optional ID for the <style> element.
 */
(0, _defineProperty2.default)(GlobalStylesCreator, "propTypes", (cov_aq42ke1ax().s[0]++, {
  children: _propTypes.default.node.isRequired,
  styles: _propTypes.default.string.isRequired,
  styleId: _propTypes.default.string
}));
/**
 * Default props for GlobalStylesCreator component.
 * @type {Object}
 * @property {string|null} styleId - Default value for styleId prop.
 */
(0, _defineProperty2.default)(GlobalStylesCreator, "defaultProps", (cov_aq42ke1ax().s[1]++, {
  styleId: null
}));
var _default = exports.default = GlobalStylesCreator;